import { ComponentProps, ReactNode } from 'react'
import { Group, Loader, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export interface LoadingIconProps extends ComponentProps<any> {
  icon?: ReactNode
  lngKey?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  children?: ReactNode
  text?: string
}
export const LoadingStatus = ({
  icon,
  size = 'sm',
  lngKey,
  children,
  text
}: LoadingIconProps) => {
  const { t } = useTranslation()
  return (
    <Group
      data-testid={'loading_status'}
      gap={'md'}
      className={'text-shell-foreground'}
    >
      {icon || (
        <Loader type={'dots'} size={size} color={'var(--sc-shell-fg)'} />
      )}
      {text ? (
        <Text size={size}>{text}</Text>
      ) : children ? (
        children
      ) : (
        <Text size={size}>
          {t(lngKey || 'loading', { defaultValue: 'Loading' })}
        </Text>
      )}
    </Group>
  )
}
